import axios from 'axios';
import qs from 'qs';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.head.querySelector('meta[name="csrf-token"]');

axios.defaults.responseType = 'json';

// Pour conserver le comportement de la version 0.27 d'axios dans le formatage des paramètres
// Il serait trop fastidieux de tout re-tester
axios.defaults.paramsSerializer = (params) => {
    const serialize = (value) => {
        if (value === null || value === undefined) {
            return undefined;
        }

        if (value instanceof Date) return value.toISOString();

        if (Array.isArray(value)) {
            // Applique récursivement sur chaque élément
            return value.map(serialize);
        }

        if (typeof value === 'object') {
            // Tout objet devient JSON
            const cloned = {};
            Object.keys(value).forEach(key => {
                const v = serialize(value[key]);
                if (v !== undefined) cloned[key] = v;
            });
            return JSON.stringify(cloned);
        }

        // Types simples : string, number, boolean
        return value;
    };

    // Sérialisation principale
    const serializedParams = {};
    Object.keys(params).forEach(key => {
        const v = serialize(params[key]);
        if (v !== undefined) serializedParams[key] = v;
    });

    // Génération finale de la query string
    return qs.stringify(serializedParams, {
        arrayFormat: 'brackets', // key[]=value pour tableaux
        encode: true,
        skipNulls: true,
    });
};

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

axios.interceptors.response.use((response) => {
    if(response && response.data && response.data.csrf) {
        document.head.querySelector('meta[name="csrf-token"]').setAttribute('content', response.data.csrf);
        axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf;
    }
    return Promise.resolve(response);
}, (error) => {
    if(error && error.response && error.response.data && error.response.data.csrf) {
        document.head.querySelector('meta[name="csrf-token"]').setAttribute('content', error.response.data.csrf);
        axios.defaults.headers.common['X-CSRF-TOKEN'] = error.response.data.csrf;
    }
    return Promise.reject(error);
});

export default axios;
